/* eslint-disable */
/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import { extend } from 'umi-request'
import { getErpToken } from '@/utils/public'

const config: any = {
    dev: 'https://dev-api.jushuitan.com',
    // dev: '//api.erp321.com',
    test: 'https://dev-api.jushuitan.com',
    uat: 'https://dev-api.jushuitan.com',
    pre: 'https://pre-api.erp321.com',
    // pre: '//api.erp321.com',
    prod: '//api.erp321.com',
}

const getBaseApi = () => {
    return config[PROJECT_CONFIG.sentryMode || PROJECT_CONFIG.mode] || config.dev
}

const baseApi = getBaseApi()

const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
}

/**
 * 异常处理程序
 */
const errorHandler = error => {
    const { response } = error
    if (response && response.status) {
        const errorText = codeMessage[response.status] || response.statusText
        const { status, url } = response

        // notification.error({
        //   message: `请求错误 ${status}: ${url}`,
        //   description: errorText,
        // });
    } else if (!response) {
        // notification.error({
        //   description: '您的网络发生异常，无法连接服务器',
        //   message: '网络异常',
        // });
    }
    return response
}

/**
 * 配置request请求时的默认参数
 */

const request = extend({
    errorHandler, // 默认错误处理, 断网提示
    credentials: 'omit', // 默认请求是否带上cookie
    method: 'POST', // 最常用的默认都是post ,除了退出登录这种特殊的要覆盖掉
    prefix: `${baseApi}`, // 请求默认前缀
    timeout: 15000 // 15秒
})

// request拦截器, 改变url 或 options.
request.interceptors.request.use(
    async (URL, options) => {
        const HEADERS = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            u_sso_token: getErpToken() || options.erpToken,
        }
        HEADERS.Authorization = getErpToken() || options.erpToken

        return {
            url: URL,
            options: {
                ...options,
                headers: {
                    ...HEADERS,
                    ...(options.headers || {}),
                },
            },
        }
    },
    { global: false },
)

/**
 * 返回拦截，校验是否登录
 */
request.interceptors.response.use(
    async response => {
        const res = await response.clone().json()
        const { data, msg, success, act, code } = res

        const token = data && typeof data === 'object' && data.token

        // 特定状态码，如果code === 10001，那么判定没有订阅，弹出订阅框

        if (token) {
            // 如果是登录接口，并且成功拿到token 存入
            localStorage.setItem('JST_DATA_TOKEN', token)
        }

        if (response && response.status) {
            const errorText = msg || codeMessage[response.status] || response.statusText
            const { status, url } = response

            if (response.status === 401 || act === 1 || code === -1) {
                // 清空本地缓存
                // localStorage.clear();
                // const href = encodeURIComponent(window.location.href);
                // showGotoLoginModal();
                return
            } else if (response.status !== 0 && response.status !== 200) {
                // notification.error({
                //   message: `请求错误 ${status}: ${url}`,
                //   description: errorText,
                // });
            }
        } else if (!response) {
            // notification.error({
            //   description: '您的网络发生异常，无法连接服务器',
            //   message: '网络异常',
            // });
        }

        return response
    },
    { global: false },
)

export default request
